import React, { useState, useEffect, useContext } from "react"
import PropTypes from "prop-types"
import Link from "../UI/Link/Link"
import * as styles from "./SecondaryNavigation-tw-styles"
import useScreenSize from "../../hooks/useScreenSize"

const SecondaryNavigation = props => {
  const {
    navItem
  } = props

  const style = styles?.defaultStyle
  const [showMenu, setShowMenu] = useState(false)
  const screen = useScreenSize()


  const linkFind =
    typeof window !== "undefined" ? window.location.href.split("/") : ""
  const newlinkFind =
    linkFind && linkFind.length ? linkFind.filter(elem => elem !== "") : null

  const items = navItem?.dropdownItemsCollection?.items
  const pageSlug = url => url.replace(/\/+$/, "").split("/").pop()

  const getSelectedItemCls = elem => {
    if (typeof window !== "undefined") {
      const pathFind = elem.url.split("/")
      const newpathFind = pathFind.filter(elem => elem !== "")
      const param = newlinkFind[newlinkFind.length - 1]
      const url = pageSlug(elem.url)
      return pageSlug(elem.url) === pageSlug(window.location.href) || window?.location?.href?.includes(url+"/#global-header")
        ? "active uppercase bodySemibold text-[#CA9953] hidden min-[1200px]:block"
        : "uppercase text-[#EBC373] notActive bodySemibold hover:text-[#CA9953]"
    }
  }

  return (
    <div className={`${style?.secondryNavWrpr} ${showMenu ? "expanded " : ""}`}>
      <div className={style?.secondryNav}>
        <div className={style?.secondryNavLinkswrpr}>
          <span
            className={style?.downArrowTogle}
            onClick={() => {
              setShowMenu(!showMenu)
            }}
          >
            {showMenu ? "Close" : "Menu"}
          </span>
        </div>
        <div className={style?.secondryNavDropDown}>
          {items &&
            items?.map((elem, index) => {
              const spl = getSelectedItemCls(elem)
              return (
                <>
                  {typeof window !== "undefined" &&
                    !showMenu &&
                    !screen?.isIpadLandscape ? (
                    spl.split(" ").includes("active") ? (
                      <div className={getSelectedItemCls(elem)}>
                        {elem?.title.toLowerCase() === "club stories" &&
                          newlinkFind[newlinkFind.length - 1] !== "club-stories"
                          ? "Overview"
                          : elem?.titlee}
                      </div>
                    ) : null
                  ) : null}
                  {(screen?.isIpadLandscape || showMenu) && (
                    <div
                      key={`secondaryNav-${index}`}
                      className={style?.secondryNavLinks}
                    >
                      <Link {...elem} className={getSelectedItemCls(elem)} />
                    </div>
                  )}
                </>
              )
            })}
            </div>
      </div>
    </div>
  )
}
SecondaryNavigation.propTypes = {
  navItem: PropTypes.shape({
    dropdownItemsCollection: PropTypes.object,
  }),
}
export default SecondaryNavigation
